import React, { useState, useMemo } from "react";
import PageLoader from "../components/ui/PageLoader";
import { useNavigate } from "react-router-dom";
import "../assets/css/style.css";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Modal from "../components/ui/Modal";
import { useAddFaqMutation, useDeleteFaqMutation, useGetFaqQuery, useUpdateFaqMutation } from "apis/campaignFaq";
import { FaPlus } from "react-icons/fa6";
import FaqEdit from "components/faq/FaqEdit";
import FaqView from "components/faq/FaqView";
import Table from "components/ui/Table";

const CampaignFaq = () => {
  const pageSize = 10;
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const {
    mutate: updateFaq,
  } = useUpdateFaqMutation();

  const {
    data,
    isPending: isFaqsPending,
  } = useGetFaqQuery();

  const {
    mutate: addFaq,
  } = useAddFaqMutation();

  const {
    mutate: deleteFaq,
  } = useDeleteFaqMutation();

  const columns = useMemo(
    () => [
      {
        accessorKey: "index",
        header: "#",
        cell: (_, rowIndex, currentPage) =>
          (currentPage - 1) * pageSize + rowIndex + 1,
        isFilter: false,
        isSortable: false,
      },
      {
        accessorKey: "question",
        header: "Question",
        isFilter: true,
      },
      {
        accessorKey: "answer",
        header: "Answer",
        isFilter: true,
      },
      {
        accessorKey: "actions",
        header: "Actions",
        cell: (row) => (
          <div className="flex items-center space-x-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedId(row._id);
                setIsEditOpen(true);
              }}
              className="edit-icon"
              title="Edit FAQ"
            >
              <FiEdit2 fontSize={20} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedId(row._id);
                deleteFaq(row._id);
              }}
              className="delete-icon"
              title="Delete FAQ"
            >
              <FiTrash2 fontSize={20} />
            </button>
          </div>
        ),
        isFilter: false,
        isSortable: false,
        stopPropagation: true,
        minWidth: "120px",
      },
    ],
    [navigate] // eslint-disable-line react-hooks/exhaustive-deps
  );

  if (isFaqsPending) {
    return <PageLoader />;
  }

  const handleViewRowClick = (row) => {
    setSelectedId(row._id);
    setIsViewOpen(true);
  };

  const AddFaqButton = () => (
    <button
      className="black-button flex items-center"
      onClick={() => setIsAddOpen(true)}
    >
      <FaPlus size={16} className="mr-2" />
      Add Faq
    </button>
  );

  return (
    <>
      <Modal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        title="Faq Edit"
        className="max-w-2xl"
      >
        <FaqEdit
          initialQuestion={data?.find((faq) => faq._id === selectedId)?.question}
          initialAnswer={data?.find((faq) => faq._id === selectedId)?.answer}
          onSubmit={(formData) => {
            updateFaq({ id: selectedId, ...formData });
            setIsEditOpen(false);
          }}
        />
      </Modal>

      <Modal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        title="Faq Add"
        className="max-w-2xl"
      >
        <FaqEdit
          initialQuestion=""
          initialAnswer=""
          onSubmit={(formData) => {
            addFaq(formData);
            setIsAddOpen(false);
          }}
        />
      </Modal>

      <Modal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title="Faq Details"
        className="max-w-2xl"
      >
        <FaqView
          question={data?.find((faq) => faq._id === selectedId)?.question}
          answer={data?.find((faq) => faq._id === selectedId)?.answer}
        />
      </Modal>

      <div className="container mx-auto">
        <Table
          title="Campaign FAQs"
          columns={columns}
          data={data || []}
          pageSize={pageSize}
          ButtonCmp={AddFaqButton}
          onRowClick={handleViewRowClick}
        />
      </div>
    </>
  );
};

export default CampaignFaq;
